// extracted by mini-css-extract-plugin
export default {"checkbox":"styles__checkbox___jUnKV","check":"styles__check___NG9of","box":"styles__box___O0xNC","invisible":"styles__invisible___m5hja"};